import NetworkConnectionActionsService from "app/actions/networkConnection.actions";
import TrackingService from 'app/services/tracking/tracking.service';
import AdminService from "external-services/diary-admin-service/admin.service";
import LoginActions from "app/actions/login.actions";
import LocalStorageService from "external-services/local-storage-service/localStorage.service";
import store from "appRoot/Store";
import {rootDisplayActions} from "app/reducers/display/slice";
import OAuth2Service from 'external-services/oauth-login/OAuth2.service';
import * as queryString from 'query-string-es5';
import { nbiSource } from "appRoot/app.constants";
import LocationService from "external-services/location-service";

const NS = 'LoginCtrl';


export default function LoginCtrl(
  $rootScope, $log, $state, $stateParams, AuthService, appValues, $location, $window
) {
  "ngInject";

  var vm = this;

  vm.appVersion = appValues.VERSION_SHORT;
  vm.username = '';
  vm.password = '';
  vm.displayErrors = false;

  vm.newVenueSelector = window.config.enableNewVenueSelector;
  vm.hideLoginScreen = false;

  // states
  vm.LOADING = 'loading';
  vm.OK = 'ok';
  vm.SUCCESS = 'success';
  vm.ERROR = 'error';
  vm.state = vm.OK;
  vm.INTERNALERROR = 'internal-error';
  vm.NETWORKERROR = 'network-error';

  // steps
  vm.LOGIN = 'login';
  vm.LOGOUT = 'logout';
  vm.VENUE = 'venue';
  vm.FORGOT = 'forgot';
  vm.FORGOTCONFIRM = 'forgot-confirm';
  vm.FORGOTUSERNOTFOUND = 'forgot-user-not-found';
  vm.step = vm.LOGIN;

  //-- define public methods
  vm.login = login;
  vm.forgotPassword = forgotPassword;
  vm.resetPassword = resetPassword;
  vm.retry = retry;
  vm.selectVenue = selectVenue;
  vm.toForgotPassword = toForgotPassword;
  vm.showResetPwOnErrorState = true;
  vm.OAuthLogin = OAuthLogin;
  vm.OAuthLogOut = OAuthLogOut;
  vm.getAccessToken = getAccessToken;
  vm.cancelOAuthLogin = cancelOAuthLogin;

  // had to do this setup early (not in setup.controller because its used before login
  NetworkConnectionActionsService.setup($rootScope);

  let accountId = $stateParams.accountId;
  let venueId = $stateParams.venueId;
  let token = $stateParams.token;
  let jumpFrom = $stateParams.jumpFrom;
  vm.enableOAuth2 = window.config.enableOAuth2 && localStorage.getItem('enableLegacyLogin') !== 'true';

  vm.state = vm.LOADING;

  const isOAuth2Login = $location.$$path === '/oauth2';
  const isJumpFromAdmin = jumpFrom && jumpFrom === 'admin';
  const isLogoutPath = $location.$$path === '/logout' || $location.$$path === '/loginlogout';
  const hasCode = !!$stateParams.code;

  TrackingService.runPendoAnonymously().then((hasGuide) => {
    console.log(NS, 'pendo initialized - hasGuide', hasGuide)
    
    /**
     * If Pendo guide is detected, we don't auto-redirect to login page. Just show the login button, so the
     * user has a chance to see the guide.
    */
    if (window.config.enableOAuth2 && hasGuide) {

      const showLogoutScreen = !hasCode && !isLogoutPath && !isOAuth2Login;

      // If any of the these conditions are true, don't go to the logout screen
      if (showLogoutScreen) {
        OAuthLogOut();
        vm.state = vm.LOGOUT;
        return;
      }
    }
    
    vm.state = vm.OK;

    // -- init logout
    AuthService.logout(true);
    if (hasCode) {
      $state.go('login', { start: $stateParams.start }, { reload: true });
      doLogin($stateParams.code);
  
    } else if (accountId && token) {
  
      // for testing, we still allow user visit legacy login page. in that way, diary should work as normal even enable OAuth2
      if (window.config.enableOAuth2) {
        OAuth2Service.setIsEnableOAuth(false);
      }
      AuthService.setToken(token);
      AuthService.checkAuth(token);
      getVenues();
    } else if (isOAuth2Login) {
      const params = queryString.parse(window.location.search);
      // login success, redirect back to login page, now try to get token
      if (params.code && !params.logout) {
        vm.state = vm.LOADING;
        if (params.state) {
          const state = OAuth2Service.parseState(params.state);
          if (state.accountId) {
            accountId = state.accountId;
          }
          if (state.venueId) {
            venueId = state.venueId;
          }
        }
        // request token
        getAccessToken().catch((error) => {
          console.log('get access token error in oauth2 ===>', error);
          retry();
        });
      } else {
        OAuthLogin();
      }
    } else if (isJumpFromAdmin) {
      vm.state = vm.LOADING;
      // jump from admin
      OAuth2Service.checkForUserAuth().then((isActive) => {
        if (isActive) {
          getVenues();
        } else {
          let state = '';
          if (accountId) {
            state = `accountId=${accountId}`;
          }
          if (venueId) {
            state = state ? `${state}&venueId=${venueId}` : `venueId=${venueId}`;
          }
          OAuth2Service.login(false, state);
        }
      });
    } else if (isLogoutPath) {
      vm.state = vm.LOGOUT;
    } else {
      if (window.config.enableOAuth2) {
        OAuth2Service.checkForUserAuth().then((isActive) => {
          if (isActive) {
            getVenues();
          } else {
            OAuthLogin();
          }
        });
      }
    }
  });


  function login(isValid) {
    if (isValid) {
      doLogin();
    } else {
      vm.displayErrors = true;
    }
  }


  function cancelOAuthLogin() {
    vm.state = vm.OK;
    vm.step = vm.LOGIN;
  }
  function doLogin(code) {
    vm.state = vm.LOADING;
    vm.loadingMsg = 'Authenticating';
    if (window.config.enableOAuth2) {
      OAuth2Service.setIsEnableOAuth(false);
    }
    
    AuthService.login(vm.username, vm.password, code).then(function () {

      // Show the new Venue selector form
      if (!code && vm.newVenueSelector) {
        vm.hideLoginScreen = true;
        store.dispatch(rootDisplayActions.setShowNewVenueSelector(true));
      } else {
        // login success
        vm.hideLoginScreen = false;
        getVenues();
      }
    }).catch(function (error) {
      console.error('error', error);
      // login fail
      vm.state = vm.ERROR;

      if (navigator.onLine) {
        if (error.status === -1 || error.status === 404 || error.status === 500 || error.status === 503) {
          vm.state = vm.INTERNALERROR;
        }
      }
      else {
        vm.state = vm.NETWORKERROR;
      }

      if (error.data) {
        vm.errorMsg = error.data.error_description;
      } else {
        vm.errorMsg = error.error_description;
      }
      $log.error(error);
    });
  }

  function retry() {
    vm.state = vm.OK;
    vm.step = vm.LOGIN;
    $state.go('login', { start: $stateParams.start }, { reload: true });
  }

  function getVenues() {
    TrackingService.trackPageView('login.select-venue');
    vm.state = vm.LOADING;
    vm.step = vm.VENUE;
    vm.loadingMsg = 'Loading Venues';
    AdminService.loadAccount(accountId)
      .then((account) => {
        return AdminService.getVenuesInfo(account, accountId);
      }) // don't use account.id or account.accountId
      .then((account) => {
        // my account success
        if (account.venues?.length) {
          vm.venues = account.venues;
          vm.state = vm.OK;
          if (vm.venues.length === 1) {
            var venue = vm.venues[0];
            if (venue.active) {
              vm.venueId = venue.id;
              selectVenue();
            }
          } else if (venueId) {
            vm.venueId = venueId;
            selectVenue();
          }

      } else {
        if (LocationService.isLocalHost(nbiSource)) {
          if (vm.newVenueSelector) {
            vm.hideLoginScreen = true;
            store.dispatch(rootDisplayActions.setShowNewVenueSelector(true));
          } else {
            vm.state = vm.ERROR;
            vm.showResetPwOnErrorState = false;
            vm.errorMsg = 'No venues found.';
            vm.showOAuthLogOut = true;
          }
        } else {
          window.location.href = window.config.adminUrl;
        }
      }
    }).catch(function (error) {
      // my account fail
      if (navigator.onLine) {
        if (error.status === -1 || error.status === 404 || error.status === 500 || error.status === 503) {
          vm.state = vm.INTERNALERROR;
        } else {
          vm.state = vm.ERROR;
        }
      } else {
        vm.state = vm.NETWORKERROR;
      }

      vm.errorMsg = error.error_description;
      $log.error(error);
      // follow code is for get all token but still got error when try load account
      if (window.config.enableOAuth2) {
        OAuth2Service.removeStoredDataForOauth();
      }
    });
  }
  function OAuthLogin() {
    vm.state = vm.LOADING;
    if (window.config.enableOAuth2) {
      OAuth2Service.setIsEnableOAuth(true);
      LocalStorageService.remove('jumpFromAdmin');
    }
    OAuth2Service.logout().finally(() => {
      OAuth2Service.login(false);
    });
  }

  function OAuthLogOut() {
    vm.showOAuthLogOut = false;
    OAuth2Service.logout().finally(() => {
      OAuth2Service.removeStoredDataForOauth();
      AuthService.logout();
    });
  }

  async function getAccessToken() {
    try {
      const accessToken = await OAuth2Service.getOAuthToken();
      OAuth2Service.setIsEnableOAuth(true);
      OAuth2Service.periodicalCheckForTokenValidity(accessToken, (newToken) => AuthService.setToken(accessToken));
      AuthService.setToken(accessToken);
      AuthService.checkAuth(accessToken);

      // Show the new Venue selector form
      if (accountId && venueId) { // jump from admin restaurant detail page.
        vm.hideLoginScreen = true;
        getVenues();
      } else {
        if (vm.newVenueSelector) {
          vm.hideLoginScreen = true;
          store.dispatch(rootDisplayActions.setShowNewVenueSelector(true));
        } else {
          // login success
          vm.hideLoginScreen = false;
          getVenues();
        }
      }

      // getVenues();
    } catch (e) {
      console.log('get access token error in oauth2', e);
      throw e;
    }
  }
  function selectVenue() {
    vm.venueErrorMsg = false;
    vm.state = vm.LOADING;
    var venue;
    for (var i = vm.venues.length - 1; i >= 0; i--) {
      venue = vm.venues[i];
      if (Number(venue.id) === Number(vm.venueId)) {
        break;
      }
    }
    if (venue && venue.active) {
      AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
      AdminService.loadVenue(
        vm.venueId,
        false, // dontBroadcast
        false, // checkReduced
        true // fetchPaymentSetting
      ).then(function () {
        vm.state = vm.OK;
        LoginActions.openApp();
      }).catch(function (err) {
        vm.state = vm.ERROR;
        vm.showResetPwOnErrorState = false;
        vm.errorMsg = 'Venue failed to load';
        $log.error('err', err);
      });
    } else {
      vm.state = vm.OK;
      vm.venueErrorMsg = 'Venue is Inactive';
    }
  }


  function toForgotPassword() {
    TrackingService.trackPageView('forgot-password');
    vm.state = vm.OK;
    vm.step = vm.FORGOT;
  }

  function forgotPassword(isValid) {
    if (isValid) {
      vm.state = vm.LOADING;
      AuthService.forgotPassword(vm.username)
        .then(function () {
          vm.state = vm.OK;
          vm.step = vm.FORGOTCONFIRM;
        })
        .catch(function (e) {
          // TODO: messaging with the backend should have no only two ways(fail or work) this should accept some messaging to be accepted as ok and other as failure

          if (e.status === '404') {
            vm.state = vm.OK;
            vm.step = vm.FORGOTUSERNOTFOUND;
          } else {
            vm.state = vm.ERROR;
            vm.showResetPwOnErrorState = true;
            vm.errorMsg = 'Error' + e.status;
          }
        });
    } else {
      vm.displayErrors = true;
    }
  }

  function resetPassword() {
    vm.state = vm.OK;
    vm.step = vm.LOGIN;
  }


}
